import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import localData from "../../localData";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

export default function Header() {
    const { wave, waveSingle, preloader } = localData.svgs;
    const {
        bg1,
        bg1Thumbnail,
        bg2,
        bg2Thumbnail,
        contact,
        contactThumbnail,
        whatWeDo,
        whatWeDoThumbnail,
        about,
        aboutThumbnail,
        works,
        worksThumbnail,
        blog,
        blogThumbnail,
        gameOver,
        gameOverThumbnail,
        line,
    } = localData.images;

    const [gallery, setGallery] = useState([
        {
            thumbnail: bg1Thumbnail,
            image: bg1,
            isImageLoaded: false,
        },
        {
            thumbnail: bg2Thumbnail,
            image: bg2,
            isImageLoaded: false,
        },
    ]);

    const location = useLocation();

    const [isBackShown, setIsBackShown] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            return;
        }
        setIsBackShown(!isBackShown);
    }, [location]);

    const updateGallery = (item) => {
        const tempGallery = [...gallery];
        const index = tempGallery.indexOf(item);
        tempGallery[index] = { ...item };
        tempGallery[index].isImageLoaded = true;
        setGallery([...tempGallery]);
    };

    useEffect(() => {
        const image = new Image();
        image.src = gallery[0].image;
        image.onload = () => updateGallery(gallery[0]);
    }, []);

    const [contents, setContents] = useState({
        isWhatWeDoLoaded: false,
        "/": (
            <div className="content home-content">
                {!gallery || !Object.keys(gallery).length ? (
                    <img src={preloader} width="300" />
                ) : (
                    <div className="swiper-custom-wrapper">
                        <Swiper
                            touchStartPreventDefault={false}
                            loop={true}
                            modules={[Navigation, Pagination, Autoplay]}
                            slidesPerView={1}
                            autoplay={{
                                delay: 4500,
                                disableOnInteraction: false,
                            }}
                            speed={1500}
                            pagination={{ clickable: true }}
                        >
                            {gallery.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <img
                                            className={`slide-bg ${index == 0 ?"background" : ""} `}
                                            data-replacement="home"
                                            src={!item.isImageLoaded && index == 0 ? item.thumbnail : item.image}
                                            alt=""
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                )}
                <div className="circle circle-primary circle-top-left"></div>
                <div className="waves">{wave}</div>

                <div className="container">
                    <h1 className="hero-title display-1">
                        <span className="hero-question">
                            {" "}
                            What keeps you up at night?{" "}
                            <span className="fill" data-lazy="fill">
                                What keeps you up at night?
                            </span>
                        </span>

                        <span className="hero-answer " data-lazy="fade" data-lazy-delay="2000">
                            we can help.
                        </span>
                    </h1>
                    <h3 className="hero-description">
                        We are a Full-Service Marketing Strategy and Advertising Consultancy.
                    </h3>

                    <a href="#contact" className="btn btn-xl btn-outline-light mt-5" underline="hover">
                        <span>Talk to us</span>
                    </a>
                </div>
            </div>
        ),
        "/what-we-do": (
            <div className="content what-we-do-content">
                <img
                    className="background what-we-do-background"
                    data-replacement="whatWeDo"
                    src={whatWeDoThumbnail}
                    alt=""
                />
                <div className="container">
                    <h1 className="hero-title display-1">what we do</h1>
                </div>
                <div className="circle circle-danger circle-top-left"></div>
                <div className="waves">{waveSingle}</div>
            </div>
        ),
        "/about": (
            <div className="content about-content">
                <div className="circle circle-danger circle-top-left"></div>
                <img className="background" src={aboutThumbnail} data-replacement="about" alt="" />
                <div className="waves">{waveSingle}</div>
                <div className="container">
                    <h1 className="hero-title display-1">who we are</h1>
                </div>
            </div>
        ),
        "/works": (
            <div className="content works-content">
                <img className="background" src={worksThumbnail} data-replacement="works" alt="" />
                <div className="container">
                    <h1 className="hero-title display-1">our works</h1>
                </div>
                <div className="circle circle-danger circle-top-left"></div>
                <img className="line" src={line} alt="" />
                <div className="circle circle-primary circle-bottom-right"></div>
                <div className="waves">{waveSingle}</div>
            </div>
        ),
        "/contact": (
            <div className="content contact-content">
                <img className="background" src={contactThumbnail} data-replacement="contact" alt="" />
                <div className="waves">{waveSingle}</div>
                <div className="container">
                    <h1 className="hero-title display-1"> speak to an expert</h1>
                </div>
            </div>
        ),
        "/blog": (
            <div className="content blog-content">
                <div className="circle circle-danger circle-top-left"></div>
                <img className="background" src={blogThumbnail} data-replacement="blog" alt="" />
                <div className="waves">{waveSingle}</div>
                <div className="container">
                    <h1 className="hero-title display-1">blog</h1>
                </div>
            </div>
        ),
        "/not-exist": (
            <div className="content not-exist-content">
                <img className="background" src={gameOverThumbnail} data-replacement="gameOver" alt="" />
                <div className="waves">{waveSingle}</div>
                <div className="container">
                    <h1 className="hero-title display-1" data-lazy="fade-up">
                        page not exist
                    </h1>
                </div>
            </div>
        ),
    });

    useEffect(() => {
        const homeImage = new Image();
        homeImage.src = bg1;

        const aboutImage = new Image();
        aboutImage.src = about;

        const contactImage = new Image();
        contactImage.src = contact;

        const whatWeDoImage = new Image();
        whatWeDoImage.src = whatWeDo;

        const worksImage = new Image();
        worksImage.src = works;

        const blogImage = new Image();
        blogImage.src = blog;

        const gameOverImage = new Image();
        gameOverImage.src = gameOver;

        const bgs = {
            homeImage,
            aboutImage,
            contactImage,
            whatWeDoImage,
            worksImage,
            blogImage,
            gameOverImage,
        };

        const replacements = [homeImage, aboutImage, contactImage, whatWeDoImage, worksImage, blogImage, gameOverImage];

        replacements.forEach((replacement) => {
            replacement.onload = () => {
                const images = document.querySelectorAll(".background");
                images.forEach((img) => {
                    console.log(img.dataset.replacement + "Image");
                    img.src = bgs[img.dataset.replacement + "Image"].src
                });
            };
        });
    }, [isBackShown]);

    const [currentPage, setCurrentPage] = useState(location.pathname);

    return (
        <header className={`hero ${location.pathname == "/" ? "home-hero" : ""} `} data-lazy-block>
            <div
                className={`card ${isBackShown ? "show-back" : ""}`}
                onTransitionEnd={() => {
                    setCurrentPage(location.pathname);
                }}
            >
                <div className="card-front">
                    {isBackShown
                        ? contents[contents[currentPage] ? currentPage : "/not-exist"]
                        : contents[contents[location.pathname] ? location.pathname : "/not-exist"]}
                </div>
                <div className="card-back">
                    {isBackShown
                        ? contents[contents[location.pathname] ? location.pathname : "/not-exist"]
                        : contents[contents[currentPage] ? currentPage : "/not-exist"]}
                </div>
            </div>
        </header>
    );
}
